import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  settingsMenuContainer: {
      marginLeft: 20
  },
}));

export default useStyles;
